import { render, staticRenderFns } from "./loan-transaction-card.vue?vue&type=template&id=4e0c8c34&scoped=true&"
import script from "./loan-transaction-card.vue?vue&type=script&lang=js&"
export * from "./loan-transaction-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0c8c34",
  null
  
)

export default component.exports